import React from "react";
import { ArrowDown } from "lucide-react";
import { clsx } from "clsx";
import { useTranslation } from "react-i18next";

export const ScrollDownIndicator = ({ isHidden }: { isHidden: boolean }) => {
  const { t } = useTranslation();
  return (
    <div
      className={clsx(
        "pointer-events-none absolute right-0 bottom-0 left-0 flex h-[100px] items-end justify-center bg-linear-to-b from-background/0 to-background transition-opacity duration-300",
        { "opacity-0": isHidden },
      )}
    >
      <div className="mb-2 flex size-8 items-center justify-center rounded-full border bg-black dark:bg-white">
        <ArrowDown className="size-4 text-white dark:text-black" />
        <span className="sr-only">{t("filters.scrollForMore")}</span>
      </div>
    </div>
  );
};
